import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { transNum } from '../../../func/func';
import { useNavigate } from 'react-router-dom';
import { isLogin } from '../../../utils/auth';
import Tags from '../../../func/Tags';

const Banner = [
  // {
  //   img: '/assets/images/modal/Mo_AnchorModal.png',
  //   link: '/promotion/땅집고옥션-오픈기념-이벤트',
  // },
  {
    img: '/assets/images/modal/Modal2.png',
    link: '/promotion/땅집고옥션-얼리버드-이벤트',
  },
  {
    img: '/assets/images/modal/Modal3.png',
    link: '/promotion/5일-무료체험-이벤트',
  },
];

const EventModal = ({ setOpenModal }: any) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  // const now = new Date();
  // const utc = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
  // const koreaTimeDiff = 9 * 60 * 60 * 1000;
  // const koreaTime = new Date(utc + koreaTimeDiff);

  // const hideDate = new Date('2025-06-10T00:00:00+09:00');

  // const filterBanner = Banner.filter((item, idx) => {
  //   // 첫 번째 배너는 6/10 00시 이후면 제외
  //   if (idx === 0 && koreaTime >= hideDate) return false;
  //   return true;
  // });
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % Banner.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [Banner]);

  return (
    <Container
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenModal(false);
      }}
    >
      <Inner>
        <img
          src={Banner[currentIndex].img}
          alt=""
          style={{
            width: '100%',

            borderTopLeftRadius: '24px',
            borderTopRightRadius: '24px',
          }}
          onClick={() => {
            navigate(Banner[currentIndex].link);
          }}
        />
        <NumberIndicator>
          <span>{currentIndex + 1}</span> / {Banner.length}
        </NumberIndicator>

        <Button_Box>
          <Close_Button
            onClick={() => {
              sessionStorage.setItem(
                'event_modal',
                `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
              );
              setOpenModal(false);
            }}
            today
          >
            오늘 하루 보지 않기
          </Close_Button>
          <Close_Button
            onClick={() => {
              setOpenModal(false);
            }}
          >
            닫기
          </Close_Button>
        </Button_Box>
      </Inner>
    </Container>
  );
};

export default EventModal;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Inner = styled.div`
  position: relative;
  width: 100%;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  display: flex;
  flex-direction: column;
  filter: blur(0);
  -webkit-filter: blur(0);
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
`;

const Button_Box = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
`;

const Close_Button = styled.button<{ today?: boolean }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${({ today }) => (today ? '#37383C9C' : '#222222')};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;
  height: 100%;
  background-color: transparent;
`;

const NumberIndicator = styled.div`
  position: absolute;
  right: 16px;
  bottom: 72px;
  background-color: #0000008f;
  color: #ffffff80;
  padding: 4px 10px;
  border-radius: 9999px;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;

  span {
    color: #ffffff;
  }
`;
